<template>
  <div class="developerdetail">
    <div class="detail_wrapper">
      <div class="box-card">
        <div class="info-header">
          <div class="title">{{userinfo.companyName}}</div>
          <div class="add">详细地址:{{userinfo.companyAddress}}</div>
          <div class="time">注册时间:{{userinfo.registerTime}}</div>
          <div>
            <el-button plain @click="goto('developer')">用户详情</el-button>
            <el-button type="primary">接口管理</el-button>
            <el-button plain @click="goto('summarydetail')">调用统计</el-button>
          </div>
          <div class="user">
            <img v-if="devStatus == '2'" src="../../../../assets/images/icon/on-use.png"/><span v-if="devStatus == '2'" style="color:#996e52;">正式用户</span>
            <img v-if="devStatus == '1'" src="../../../../assets/images/icon/try.png"/><span v-if="devStatus == '1'" style="color:#479efe;">试用用户</span>
            <img v-if="devStatus == '3'" src="../../../../assets/images/icon/outDate.png"/><span v-if="devStatus == '3'" style="color:#666;">过期用户</span>
            <img v-if="devStatus == '0'" src="../../../../assets/images/icon/invalid.png"/><span v-if="devStatus == '0'" style="color:#878787">未生效用户</span>
            <img v-if="devStatus == '4'" src="../../../../assets/images/icon/forbiden.png"/><span v-if="devStatus == '4'" style="color:#ed4a3a;">禁用用户</span>
            <img v-if="devStatus == '5'" src="../../../../assets/images/icon/other.png"/><span v-if="devStatus == '5'" style="color:#4a6589;">其他用户</span>
          </div>
        </div>
      </div>

      <div class="box-card">
        <div>
          <div class="tlc" style="margin-bottom:16px;">
            <!-- 当前开通方式：{{type === 1 ? '按时间开通' : '按数量开通'}} -->
            <el-radio-group v-model="type" size="small">
              <el-radio-button label="1">按时间</el-radio-button>
              <el-radio-button label="2">按数量</el-radio-button>
            </el-radio-group>
          </div>
          <!-- 按时段开通  显示资源 -->
          <el-table
          v-show="type == 1"
          :data="timeTable"
          border
          header-row-class-name="header-row-class-name"
          style="width: 100%">

            <el-table-column
            label="接口名称"
            align="center">
              <template slot-scope="scope">
                {{scope.row.apiResourceDto.name}}
              </template>
            </el-table-column>

            <!-- <el-table-column
              label="接口开通类型"
              width="120"
              align="center">
              <template slot-scope="scope">
                <div v-if="scope.row.type === 1">按时段</div>
                <div v-if="scope.row.type === 2">按数量</div>
              </template>
            </el-table-column> -->

            <el-table-column
            label="开通时段"
            prop="startTime"
            align="center">
              <template slot-scope="scope">
                <div v-if="scope.row.type === 1">{{scope.row.startTime}} 至 {{scope.row.endTime}}</div>
                <div v-else>/</div>
              </template>
            </el-table-column>

            <el-table-column
            label="剩余天数"
            prop="surplusDays"
            width="120"
            align="center">
            </el-table-column>

            <el-table-column
              label="每日接口调用上限"
              align="center"
              width="150"
              prop="maxInvokePerDay">
            </el-table-column>

            <el-table-column
              label="每日下载量上限"
              align="center"
              width="150"
              prop="maxDownloadPerDay">
            </el-table-column>

            <el-table-column
            label="状态"
            width="120"
            align="center">
              <template slot-scope="scope">
                <span v-if="scope.row.status === 2" style="color:#36B935;">服务中</span>
                <span v-if="scope.row.status === 1" style="color:#479efe;">试用</span>
                <span v-if="scope.row.status === 3" style="color:#666;">过期</span>
                <span v-if="scope.row.status === 0" style="color:#878787;">未生效</span>
                <span v-if="scope.row.status === 4" style="color:#ed4a3a;">禁用</span>
                <span v-if="scope.row.status === 9" style="color:#666;">/</span>
              </template>
            </el-table-column>
          </el-table>

          <!-- 按调用量开通 显示资源 -->
          <el-table
            v-show="type == 2"
            :data="numberTable"
            header-row-class-name="header-row-class-name"
            border
            style="width: 100%">

            <el-table-column
            label="接口名称"
            align="center">
              <template slot-scope="scope">
                {{scope.row.apiResourceDto.name}}
              </template>
            </el-table-column>

            <!-- <el-table-column
              label="接口开通类型"
              width="120"
              align="center">
              <template slot-scope="scope">
                <div v-if="scope.row.type === 1">按时段</div>
                <div v-if="scope.row.type === 2">按数量</div>
              </template>
            </el-table-column> -->

            <el-table-column
            label="接口调用上限"
            prop="invokeLimit"
            align="center">
            </el-table-column>

            <el-table-column
            label="去重下载上限"
            prop="downloadLimit"
            align="center">
              <template slot-scope="scope">
                <div v-if="scope.row.apiResourceDto.id == 1">/</div>
                <div v-else>{{scope.row.downloadLimit}}</div>
              </template>
            </el-table-column>

            <!-- <el-table-column
            label="调用总量"
            prop="invokeCount"
            align="center">
            </el-table-column> -->

            <el-table-column
            label="去重下载"
            prop="downloadCount"
            align="center">
              <template slot-scope="scope">
                <div v-if="scope.row.apiResourceDto.id == 1">/</div>
                <div v-else>{{scope.row.downloadCount}}</div>
              </template>
            </el-table-column>

            <el-table-column
            label="累计下载"
            prop="totalDownloadCount"
            align="center">
              <template slot-scope="scope">
                <div v-if="scope.row.apiResourceDto.id == 1">/</div>
                <div v-else>{{scope.row.totalDownloadCount}}</div>
              </template>
            </el-table-column>

            <el-table-column
            label="状态"
            width="120"
            align="center">
              <template slot-scope="scope">
                <span v-if="scope.row.status === 2" style="color:#36B935;">服务中</span>
                <span v-if="scope.row.status === 1" style="color:#479efe;">试用</span>
                <span v-if="scope.row.status === 3" style="color:#666;">过期</span>
                <span v-if="scope.row.status === 0" style="color:#878787;">未生效</span>
                <span v-if="scope.row.status === 4" style="color:#ed4a3a;">禁用</span>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </div>
  </div>
</template>
<script type="text/babel">
import detailService from '@/service/front/detailService'
import devService from '@/service/devService'
import {mapGetters} from 'vuex'
export default {
  data () {
    return {
      details: {},
      emptyData: [{}],
      tableData: [],
      developSecource: [],
      timeTable: [],
      numberTable: [],
      devStatus: '',
      type: '1',
      zuheData: {}
    }
  },
  name: 'developerdetail',
  async mounted () {
    await this.fetchDevResource()
    this.getDeveloperStatus()
    this.getDeveloperZuhe()
  },
  computed: {
    ...mapGetters(['userinfo'])
  },
  methods: {
    // 获取开发者状态
    async getDeveloperStatus () {
      try {
        this.devStatus = await devService.getDeveloperStatus({developerId: this.userinfo.id})
      } catch (e) {
        this.$message.error(e && e.msg)
      }
    },
    // 获取组合开通信息
    async getDeveloperZuhe () {
      try {
        let res = await devService.getUserZuheOpen({userId: this.userinfo.id})
        if (!res) {
          return;
        }
        res = {
          ...res,
          maxInvokeName: res.name,
          surplusDays: '/',
          type: 9,
          status: 9
        }
        this.zuheData = res
        this.timeTable.push({
          ...res,
          apiResourceDto: {
            name: res.maxInvokeName
          },
          order: 999
        })
      } catch (e) {
        this.$message.error(e && e.msg)
      }
    },
    // 跳转页面
    goto (name) {
      this.$router.push({name: name})
    },
    async reset () {
      this.$confirm('重置后将使用新的 Developer Id 和 Access Secret, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'info'
      }).then(async () => {
        try {
          await detailService.resetClient()
          await this.detailService()
        } catch (e) {
          this.$message.error(e && e.msg)
        }
      }).catch(() => {
      })
    },
    // 查询用户开通详情
    async fetchDevResource () {
      try {
        this.developSecource = await devService.getDevelopStatistics({developerId: this.userinfo.id})
        // 过滤apiResourceDto.name是试题的，然后questionV4的改名为试题
        this.developSecource = this.developSecource.filter(item => item.apiResourceDto.name !== '试题')
        this.developSecource.forEach(item => {
          if (item.apiResourceDto.name === 'questionV4') {
            item.apiResourceDto.name = '试题'
          }
        })
        let sortArr = ['通用', '文档', '试卷', '试题', '微课'];
        this.numberTable = []
        this.timeTable = []
        this.developSecource.forEach((item) => {
          if (item.type == 2) {
            this.numberTable.push({
              ...item,
              order: sortArr.indexOf(item.apiResourceDto.name) > -1 ? sortArr.indexOf(item.apiResourceDto.name) : 999
            })
          } else {
            this.timeTable.push({
              ...item,
              order: sortArr.indexOf(item.apiResourceDto.name) > -1 ? sortArr.indexOf(item.apiResourceDto.name) : 999
            })
          }
          this.numberTable = this.numberTable.sort((a, b) => {
            return a.order - b.order
          })
          this.timeTable = this.timeTable.sort((a, b) => {
            return a.order - b.order
          })
          this.type = this.timeTable.length > 0 ? 1 : 2;
        })
      } catch (e) {
        console.log(e)
        this.$message.error(e && e.msg)
      }
    },
    async detailService () {
      try {
        this.details = await detailService.fetchDetail()
      } catch (e) {
        this.$message.error(e && e.msg)
      }
    },
    pushTo (name) {
      let url = '/front/developer/summary?name=' + name
      this.$store.commit('DEVDEFAULTVX', url)
      this.$router.push({path: url})
    }
  }
}
</script>
<style scoped>
  .developerdetail{
    height: 100%;
    width: 100%;
    margin-top: 30px;
    padding-bottom: 60px;
  }
  .developerdetail .detail_wrapper{
    height: 100%;
    width: 1200px;
    margin: 0 auto;
    /* padding: 30px; */
  }

  .developerdetail .detail_wrapper .box-card{
    /* margin: 20px 0px; */
    padding: 20px 24px;
    margin-bottom: 20px;
    background-color: #fff;
    position: relative;
  }

  .developerdetail .detail_wrapper .info-header{
    background: #ffffff;
    /* padding: 20px 24px; */
    /* position: relative; */
    color: #333;
  }
  .developerdetail .detail_wrapper .info-header .title{
    font-size: 18px;
    font-weight: bold;
    margin-bottom: 20px;
  }
  .developerdetail .detail_wrapper .info-header .add,.developerdetail .detail_wrapper .info-header .time{
    font-size: 14px;
    color: gray;
    margin-bottom: 20px;
    max-width: 900px;
  }
  .developerdetail .detail_wrapper .info-header .user span{
    position: absolute;
    right: 121px;
    top: 54px;
    font-size: 18px;
    font-weight: bold;
  }
  .developerdetail .detail_wrapper .info-header .user img{
    position: absolute;
    right: 200px;
    top: 50px;
  }
  .developerdetail .detail_wrapper .toolbar .el-select {
    width: 130px;
  }
  .developerdetail .detail_wrapper .toolbar .input-with-select .el-input-group__prepend {
    background-color: #fff;
  }
  .developerdetail .detail_item{
    margin-bottom: 10px;
  }
  .developerdetail .detail_item .detail_label{
    color: #333333;
    font-size:16px;
    font-family:MicrosoftYaHei-Bold;
    font-weight:bold;
  }
  .developerdetail .detail_item .detail_value{
     color: #666666;
    font-size:16px;
    font-family:MicrosoftYaHei;
    font-weight:400;
     margin-right: 20px;
  }

  .developerdetail .layout_table{
    background:#F7F7F7;
    border:1px solid #E2E2E2;
    border-radius:4px;
    margin-top: 40px;
  }
  .developerdetail .layout_table .content_table{
    margin: 20px 60px;
  }

</style>
<style type="text/css">

</style>



// WEBPACK FOOTER //
// src/pages/front/developer/detail/index.vue